import { IconNetwork } from '@tabler/icons-react';
import { TabProps } from '../../layout/interfaces/secondarySidebar';
import { AccountAccess } from './AccountAccess';
import Authentication from './Authentication';
import Cloudwatch from './Cloudwatch';
import { Connectivity } from './Connectivity/Connectivity';
import DeleteAccount from './DeleteAccount';
import { Members } from './Members';
import { MemberRole } from './models';
import { Timezone } from './Timezone';
import WorkspaceList from './Workspace/components/WorkspaceList/WorkspaceList';

export const TEAM_TABS: Array<
  TabProps & {
    visibilityResolver?: (ctx: {
      isOwner?: boolean;
      isWorkspacesEnabled?: boolean;
      isISVTeam?: boolean;
      isVPCPeeringConnectionEnabled?: boolean
    }) => boolean;
  } & { SVGIcon?: React.FC<any> }
> = [
    {
      Component: WorkspaceList,
      label: 'Workspaces',
      route: '/team/workspaces',
      icon: 'plan',
      visibilityResolver: ({ isWorkspacesEnabled, isISVTeam }) => !!(isWorkspacesEnabled && isISVTeam)
    },
    {
      Component: Connectivity,
      label: 'Connectivity',
      route: '/team/connectivity',
      SVGIcon: IconNetwork,
      visibilityResolver: ({ isVPCPeeringConnectionEnabled }) => !!isVPCPeeringConnectionEnabled
    },
    {
      Component: Members,
      label: 'Members',
      route: '/team/members',
      icon: 'team'
    },
    {
      Component: Cloudwatch,
      label: 'Activity Logs',
      route: '/team/cloudwatch',
      icon: 'cloudwatch'
    },
    {
      Component: Authentication,
      label: 'Authentication',
      route: '/team/authentication',
      icon: 'authentication',
      visibilityResolver: ({ isOwner }) => isOwner
    },
    {
      Component: Timezone,
      label: 'Timezone',
      route: '/team/timezone',
      icon: 'timezone'
    },
    {
      Component: AccountAccess,
      label: 'Data & Privacy',
      route: '/team/account-access',
      icon: 'account-access'
    },
    {
      Component: DeleteAccount,
      label: 'Delete Account',
      route: '/team/delete-account',
      className: 'error',
      icon: 'delete'
    }
  ];

export const MEMBER_ROLES: MemberRole[] = [
  {
    name: 'Owner',
    value: 1,
    id: '1'
  },
  {
    name: 'Member',
    value: 2,
    id: '2'
  }
];
